import { useState } from 'react';
import beTwMerge from '@/utils/beTwMerge';
import { subHeadersStyles } from '@/consts/builder';
import RichText from '@/components/RichText/RichText';
import { formatRichText, isRichTextEmpty } from '@/utils/builderUtils';
import { FAQItemType } from '@/types/builder';

export default function FAQ({ item }: { item: FAQItemType }) {
  const { answer, title, titleSize, titleTag } = item;
  const [isShowAnswer, setIsShowAnswer] = useState<boolean>(false);
  const onClick = () => {
    setIsShowAnswer(prev => !prev);
  };
  const TitleTag = titleTag || 'h3';
  const renderIcon = () => {
    let heightClass = 'tw-h-[41px] desktop:tw-h-[49px]';
    if (titleSize === 'h3') {
      heightClass = 'tw-h-[33px] desktop:tw-h-[41px]';
    }
    if (titleSize === 'h4') {
      heightClass = 'tw-h-[22px] desktop:tw-h-[24px]';
    }
    return (
      <div className={`tw-w-6 ${heightClass} tw-flex tw-items-center`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d={isShowAnswer ? 'M6 12.5H18' : 'M12 6.5V18.5M6 12.5H18'}
            stroke="#2C2C2C"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    );
  };

  return (
    <div className="tw-flex tw-flex-col tw-items-start tw-self-stretch tw-gap-2">
      {title && (
        <div
          className="tw-flex tw-items-start tw-self-stretch tw-gap-2 tw-cursor-pointer"
          onClick={onClick}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') onClick();
          }}
          role="button"
          tabIndex={0}
        >
          {renderIcon()}
          <TitleTag className={beTwMerge('tw-m-0', subHeadersStyles[titleSize])}>{title}</TitleTag>
        </div>
      )}
      {!isRichTextEmpty(answer) && (
        <div className={beTwMerge('tw-w-full tw-block', !isShowAnswer && 'tw-hidden')}>
          <RichText className="tw-w-[calc(100%-32px)] tw-pl-8 tw-break-words" content={formatRichText(answer)} />
        </div>
      )}
    </div>
  );
}
